import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { ModalActions } from "../../../common/Buttons";

/**
 * Give Training only — multi-select trainees in columns of USERS_PER_COLUMN; extra columns as needed.
 * Get Training continues to use the separate "Select the Trainer" modal.
 */
const USERS_PER_COLUMN = 8;

const chunkIntoColumns = (options, perColumn) => {
  const cols = [];
  for (let i = 0; i < options.length; i += perColumn) {
    cols.push(options.slice(i, i + perColumn));
  }
  return cols;
};

const SelectTraineesModal = ({
  onClose,
  loading = false,
  traineeOptions = [],
  selectedTraineeIds = [],
  onToggleTrainee,
  onNext,
}) => {
  const columns = chunkIntoColumns(traineeOptions, USERS_PER_COLUMN);
  const columnCount = Math.max(columns.length, 1);

  const renderOption = (trainee) => {
    const id = String(trainee.id);
    const checked = selectedTraineeIds.includes(id);
    return (
      <label key={id} className="select-trainee-option">
        <input
          type="checkbox"
          checked={checked}
          onChange={() => onToggleTrainee(id)}
        />
        <span className="select-trainee-name">{trainee.label}</span>
      </label>
    );
  };

  return (
    <div className="revision-modal-overlay">
      <div
        className="revision-modal-content select-trainee-modal"
        style={
          !loading && traineeOptions.length > 0
            ? { "--trainee-column-count": columnCount }
            : undefined
        }
      >
        <div className="revision-modal-header">
          <h3 className="revision-modal-title select-trainee-modal-title">
            Select the Trainee(s)
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="revision-close-button"
            title="Close"
            aria-label="Close modal"
          >
            <FontAwesomeIcon icon={faTimes} size="1x" color="#6c757d" />
          </button>
        </div>

        <hr className="divider" />

        <div className="select-trainee-body">
          <div className="select-trainee-label">Trainee:</div>
          {loading ? (
            <p className="select-trainee-empty">Loading trainees…</p>
          ) : traineeOptions.length === 0 ? (
            <p className="select-trainee-empty">No matching users.</p>
          ) : (
            <div className="select-trainee-columns">
              {columns.map((col, colIdx) => (
                <div
                  key={`trainee-col-${colIdx}`}
                  className="select-trainee-column"
                >
                  {col.map(renderOption)}
                </div>
              ))}
            </div>
          )}
        </div>

        <hr className="divider" />

        <div className="select-trainee-footer">
          <ModalActions
            onClose={onClose}
            onSubmit={onNext}
            submitLabel="Next"
            closeLabel="Close"
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default SelectTraineesModal;
